import { render, staticRenderFns } from "./LegacyTransactionHistory.vue?vue&type=template&id=0616570e&"
import script from "./LegacyTransactionHistory.vue?vue&type=script&lang=js&"
export * from "./LegacyTransactionHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports